import React from 'react';
import { UsersBrowser } from 'components/UsersBrowser/UsersBrowser';
import { UserManager } from 'components/UserManager/UserManager';

export function UsersView() {
    return (
        <div className="main_views_cont">
            <div className="main_view_left_cont"></div>
            <div className="main_view_center_cont">
                <UsersBrowser />
            </div>
            <div className="main_view_right_cont">
                <UserManager />
            </div>
        </div>
    );
}
